module.exports = __webpack_public_path__ + "img/Signing.2220e42f.png";